const defaultColor: SlugColorType = 'gray';

export const getContactStateColor = (
  status?: LatestContactState
): SlugColorType => {
  if (!status) return defaultColor;

  // Fold case so legacy uppercase tokens and the new lowercase `snake_case`
  // tokens map to the same colour.
  switch (status.toLowerCase()) {
    case 'active':
      return 'main';
    case 'ready_for_outreach':
    case 'ai_ready_to_start':
      return 'warning';
    case 'goal_reached':
      return 'success';
    case 'outreach_failed':
    case 'ai_failed':
      return 'danger';
    default:
      return defaultColor;
  }
};
